/**
 * Returns a function that as long as it continues to be invoked, won't be triggered.
 * @param {Function} fn - Callback function.
 * @param {number} [wait=300] - Delay (in milliseconds).
 * @returns {Function}
 */
function debounce(fn, wait = 300) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

if (!customElements.get("popover-content")) {
    

  var CustomHTMLElement = class extends HTMLElement {
    constructor() {
      super();
      this._hasSectionReloaded = false;
      if (Shopify.designMode) {
        this.rootDelegate.on("shopify:section:select", (event) => {
          const parentSection = this.closest(".shopify-section");
          if (event.target === parentSection && event.detail.load) {
            this._hasSectionReloaded = true;
          }
        });
      }
    }
    get rootDelegate() {
      return (this._rootDelegate =
        this._rootDelegate || new main_default(document.documentElement));
    }
    get delegate() {
      return (this._delegate = this._delegate || new main_default(this));
    }
    showLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:start");
    }
    hideLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:end");
    }
    untilVisible(
      intersectionObserverOptions = { rootMargin: "30px 0px", threshold: 0 }
    ) {
      const onBecameVisible = () => {
        this.classList.add("became-visible");
        this.style.opacity = "1";
      };
      return new Promise((resolve) => {
        if (window.IntersectionObserver) {
          this.intersectionObserver = new IntersectionObserver((event) => {
            if (event[0].isIntersecting) {
              this.intersectionObserver.disconnect();
              requestAnimationFrame(() => {
                resolve();
                onBecameVisible();
              });
            }
          }, intersectionObserverOptions);
          this.intersectionObserver.observe(this);
        } else {
          resolve();
          onBecameVisible();
        }
      });
    }
    disconnectedCallback() {
      var _a;
      this.delegate.destroy();
      this.rootDelegate.destroy();
      (_a = this.intersectionObserver) == null ? void 0 : _a.disconnect();
      delete this._delegate;
      delete this._rootDelegate;
    }
  };
  var OpenableElement = class extends CustomHTMLElement {
    static get observedAttributes() {
      return ["open"];
    }
    constructor() {
      super();
      if (Shopify.designMode) {
        this.rootDelegate.on("shopify:section:select", (event) =>
          filterShopifyEvent(event, this, () => (this.open = true))
        );
        this.rootDelegate.on("shopify:section:deselect", (event) =>
          filterShopifyEvent(event, this, () => (this.open = false))
        );
      }
      if (this.hasAttribute("append-body")) {
        const existingNode = document.getElementById(this.id);
        this.removeAttribute("append-body");
        if (existingNode && existingNode !== this) {
          existingNode.replaceWith(this.cloneNode(true));
          this.remove();
        } else {
          document.body.appendChild(this);
        }
      }
    }
    connectedCallback() {
      this.delegate.on(
        "click",
        ".openable__overlay",
        () => (this.open = false)
      );
      this.delegate.on("click", '[data-action="close"]', (event) => {
        event.stopPropagation();
        this.open = false;
      });
    }
    get requiresLoading() {
      return this.hasAttribute("href");
    }
    get open() {
      return this.hasAttribute("open");
    }
    set open(value) {
      if (value) {
        (async () => {
          await this._load();
          this.clientWidth;
          this.setAttribute("open", "");
        })();
      } else {
        this.removeAttribute("open");
      }
    }
    get shouldTrapFocus() {
      return true;
    }
    get returnFocusOnDeactivate() {
      return (
        !this.hasAttribute("return-focus") ||
        this.getAttribute("return-focus") === "true"
      );
    }
    // Temp no need to use focusTrap
    // get focusTrap() {
    //   return (this._focusTrap =
    //     this._focusTrap ||
    //     createFocusTrap(this, {
    //       fallbackFocus: this,
    //       initialFocus: this.hasAttribute("initial-focus-selector")
    //         ? this.getAttribute("initial-focus-selector")
    //         : void 0,
    //       clickOutsideDeactivates: (event) =>
    //         !(
    //           event.target.hasAttribute("aria-controls") &&
    //           event.target.getAttribute("aria-controls") === this.id
    //         ),
    //       allowOutsideClick: (event) =>
    //         event.target.hasAttribute("aria-controls") &&
    //         event.target.getAttribute("aria-controls") === this.id,
    //       returnFocusOnDeactivate: this.returnFocusOnDeactivate,
    //       onDeactivate: () => (this.open = false),
    //       preventScroll: true,
    //     }));
    // }
    // attributeChangedCallback(name, oldValue, newValue) {
    //   switch (name) {
    //     case "open":
    //       if (oldValue === null && newValue === "") {
    //         if (this.shouldTrapFocus) {
    //           setTimeout(() => this.focusTrap.activate(), 150);
    //         }
    //         triggerEvent(this, "openable-element:open");
    //       } else if (newValue === null) {
    //         if (this.shouldTrapFocus) {
    //           this.focusTrap.deactivate();
    //         }
    //         triggerEvent(this, "openable-element:close");
    //       }
    //   }
    // }
    async _load() {
      if (!this.requiresLoading) {
        return;
      }
      triggerNonBubblingEvent(this, "openable-element:load:start");
      const response = await fetch(this.getAttribute("href"));
      const element = document.createElement("div");
      element.innerHTML = await response.text();
      this.innerHTML = element.querySelector(
        this.tagName.toLowerCase()
      ).innerHTML;
      this.removeAttribute("href");
      triggerNonBubblingEvent(this, "openable-element:load:end");
    }
  };
  window.customElements.define("openable-element", OpenableElement);

  var PopoverContent = class extends OpenableElement {
    connectedCallback() {
      super.connectedCallback();
      this.delegate.on("click", ".popover__overlay", () => (this.open = false));
    }
    // attributeChangedCallback(name, oldValue, newValue) {
    //   super.attributeChangedCallback(name, oldValue, newValue);
    //   switch (name) {
    //     case "open":
    //       document.documentElement.classList.toggle("lock-mobile", this.open);
    //   }
    // }
  };
  document.addEventListener("DOMContentLoaded", function () {
    const dropdownToggle = document.querySelector(".popover-button");
    const dropdownMenu = document.querySelector(".popover__content");
    const popover = document.querySelector(".popover");

    // if (!dropdownToggle || !dropdownMenu || !popover) return;
    const toggleDropdown = (expand) => {
      // dropdownMenu.classList.toggle("show", expand);
      dropdownToggle.setAttribute("aria-expanded", expand);
      if (expand) {
        popover.open = true;
      } else {
        popover.open = false;
      }
    };

    dropdownToggle.addEventListener("click", function (e) {
      e.preventDefault();
      const isExpanded = this.getAttribute("aria-expanded") === "true";
      // console.log(!isExpanded);
      toggleDropdown(!isExpanded);
    });

    document.addEventListener("click", function (e) {
      if (
        !dropdownToggle.contains(e.target) &&
        !dropdownMenu.contains(e.target)
      ) {
        toggleDropdown(false);
      }
    });

    dropdownMenu.addEventListener("click", function (e) {
      e.stopPropagation();
    });

    // dropdownToggle.addEventListener('keydown', function (e) {
    //   if (e.key === 'Enter' || e.key === ' ') {
    //     e.preventDefault();
    //     const isExpanded = this.getAttribute('aria-expanded') === 'true';
    //     toggleDropdown(!isExpanded);
    //   }
    // });
  });
  window.customElements.define("popover-content", PopoverContent);
}
